import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LoginData } from 'src/app/models/loginData';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})

export class ForgetPasswordComponent implements OnInit {
  hide = true;

  LoginData: LoginData;
  loginlist: LoginData[];
  constructor(private router: Router) {
    this.LoginData = new LoginData();
    this.loginlist = [];
  }
  ngOnInit(): void {

  }


}